import accountLogin from '@/components/account/account-login/account-login.vue';
import accountLoginFooter from '@/components/account/account-login/footer/footer.vue';

export default {
  components: {
    accountLogin,
    accountLoginFooter,
  },
};



// WEBPACK FOOTER //
// ./src/components/cms/account-combined-login/account-combined-login.js